import { BaseDb } from "common/BaseDb"
import { WorklogsSchemaWithId } from "components/daily/worklogs/worklogs.schema"

class WorklogsDb extends BaseDb<WorklogsSchemaWithId> {
    // no-op on web/base builds - offline sync only exists on the mobile (.mobile.ts) variant of this class,
    // resolved at bundle time for mobile-only call sites that import this module by its bare path
    async sync(): Promise<{ skipped: boolean; total: number; succeeded: number; failed: number; deletedRemotely: number[] }> {
        return { skipped: true, total: 0, succeeded: 0, failed: 0, deletedRemotely: [] }
    }

    async getOutstandingCount(): Promise<number> {
        return 0
    }
}

const worklogsDb = new WorklogsDb("daily/worklogs")
export default worklogsDb
